import { SelectionModel } from '@angular/cdk/collections';
import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { CreateTrademarkFamilyDialogComponent } from 'src/app/dialogs/create-trademark-family-dialog/create-trademark-family-dialog.component';
import { Territory } from 'src/app/models/territory';
import { Trademark, TrademarkDTO, TrademarkDTOSearch } from 'src/app/models/trademark';
import { TrademarkFamily } from 'src/app/models/trademarkFamily';
import { MessageService } from 'src/app/services/message.service';
import { TrademarkFamilyCreate, TrademarkFamilyService } from 'src/app/services/trademark-family.service';
import { TrademarkService } from 'src/app/services/trademark.service';

@Component({
  selector: 'app-trademark-declare-single',
  templateUrl: './trademark-declare-single.component.html',
  styleUrls: ['./trademark-declare-single.component.scss']
})
export class TrademarkDeclareSingleComponent {

  public query: { identifierNumber?: string, countryOfDesignation: string[] } = {
    identifierNumber: undefined,
    countryOfDesignation: []
  };

  displayedColumns: string[] = ['select', 'name', 'identifierNumber', 'countryOfDesignation', 'niceClassification', 'status', 'representation'];
  public trademarks: TrademarkDTO[] = [];
  public trademarksWithoutDesignations: TrademarkDTO[] = [];
  dataSource: MatTableDataSource<TrademarkDTO> = new MatTableDataSource<TrademarkDTO>([])
  public selection = new SelectionModel<TrademarkDTO>(true, []);

  public newClass: {
    classNumber?: number,
    details?: string
  } = {
      classNumber: undefined,
      details: undefined
    };

  public loading: boolean = false;
  public found: boolean = false;
  public done: boolean = false;

  familyModes: { value: string, label: string, selected: boolean }[] = [
    { selected: false, label: 'TRADEMARK_DECLARE.IMPORT_TRADEMARK_FAMILY_SELECT', value: 'select' },
    { selected: false, label: 'TRADEMARK_DECLARE.IMPORT_TRADEMARK_FAMILY_CREATE', value: 'create' }
  ];
  familyMode?: 'create' | 'select' = undefined;
  family?: TrademarkFamily;

  constructor(
    private _message: MessageService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private trademarkService: TrademarkService,
    private trademarkFamilyService: TrademarkFamilyService,
    private translate: TranslateService
  ) {
  }

  back() {
    this.router.navigate([".."], { relativeTo: this.route })
  }

  // isDeclareDisabled() {
  //   return !this.trademark || (!this.trademark.registrationNumber && !this.trademark.applicationNumber) || !this.trademark.countryOfDesignation || this.loading;
  // }

  isSearchDisabled() {
    return this.loading || !this.query.identifierNumber || !this.query.countryOfDesignation || this.query.countryOfDesignation.length === 0;
  }

  cancel() {
    this.done = false;
    this.loading = false;
  }

  onCountryOfDesignationChange(event: { value: Territory }) {
    if (event && event.value) {
      this.query.countryOfDesignation = event.value.alternateCodes ? [event.value.id, ...event.value.alternateCodes] : [event.value.id];
    }
  }

  onFamilyModeChange(event: any) {
    this.family = undefined;
  }

  async search() {
    if (this.query.identifierNumber && this.query.countryOfDesignation) {
      this.loading = true;
      this.done = false;
      this.trademarks = [];
      try {
        const trademarks = await this.trademarkService.search([{ identifierNumber: this.query.identifierNumber.trim(), countryOfDesignation: this.query.countryOfDesignation }]);
        trademarks.forEach((trademark: TrademarkDTOSearch) => {
          if (!trademark.error) {
            if (this.familyMode && ['create', 'select'].includes(this.familyMode)) {
              trademark.family = {
                mode: this.familyMode,
                ref: this.family?._id
              }
            }
            if (!trademark.designation) {
              trademark.designations = trademarks.filter(tm => this._isDesignation(trademark, tm));
            }
            this.trademarks.push(trademark)
          }
        });
        this.trademarksWithoutDesignations = this.trademarks.filter((trademark) => !trademark.designation);
        this.dataSource = new MatTableDataSource<TrademarkDTO>(this.trademarksWithoutDesignations);
        this.loading = false;
        this.done = true;
      } catch (err: any) {
        if (err && err.status === 404) {
          this.found = false;
          this.loading = false;
          this.done = true;
        } else {
          this.loading = false;
          this.done = false;
          this.toastr.error(`ERRORS.GENERIC`);
        }
      }
    }
  }

  _isDesignation(trademarkA: TrademarkDTOSearch, trademarkB: TrademarkDTOSearch) {
    return (trademarkA.type === trademarkB.type)
      && (trademarkA.kind === trademarkB.kind)
      && (trademarkA.status === trademarkB.status)
      && (trademarkA.applicationDate && trademarkB.applicationDate ? moment(trademarkA.applicationDate).isSame(moment(trademarkB.applicationDate)) : true)
      && (trademarkA.countryOfDesignation !== trademarkB.countryOfDesignation)
      && (
        (trademarkA.applicationNumber === trademarkB.applicationNumber)
        || (trademarkA.registrationNumber == trademarkB.registrationNumber)
        || (trademarkA.identifierNumber == trademarkB.identifierNumber)
      )
  }

  public getTrademarksFromSelection() {
    const trademarks: TrademarkDTO[] = [];
    this.selection.selected.forEach((trademark) => {
      if (trademark.designation || trademark.countryOfDesignation !== "WO" || !trademark.designations) {
        return trademarks.push(trademark);
      }
      return trademarks.push(...trademark.designations);
    });
    return trademarks;
  }

  isSelected(row: TrademarkDTO) {
    return this.selection.selected.includes(row)
   }

  isDisabled(row: TrademarkDTO) {
    return false;
  }

  isAllSelected() {
    return this.dataSource.data.filter(row => !this.isDisabled(row)).every(row => this.isSelected(row));
  }

  isSomeSelected() {
    return !this.dataSource.data.filter(row => !this.isDisabled(row)).every(row => this.isSelected(row)) && this.dataSource.data.filter(row => !this.isDisabled(row)).some(row => this.isSelected(row));
  }

  toggleAllRows() {
    if (this.isAllSelected()) {
      const difference = _.differenceBy(this.selection.selected, this.dataSource.data.filter(row => !this.isDisabled(row)), x => `${x.countryOfDesignation}_${x.identifierNumber}`)
      this.selection.setSelection(...difference)
      return;
    }
    this.selection.setSelection(...[...this.selection.selected, ...this.dataSource.data.filter(row => !this.isDisabled(row)).filter(row => !this.isSelected(row))])
  }

  toggle(row: TrademarkDTO) {
    if (this.isSelected(row)) {
      this.selection.setSelection(...this.selection.selected.filter(doc => doc !== row))
    } else {
      this.selection.setSelection(...[...this.selection.selected, row])
    }
  }

  canDeclare() {
    return this.selection.selected.length > 0;
  }


  onSortChange(event: any) {

    if (event.active === 'tmName') {
      this.trademarks.sort((a, b) => event.direction === 'desc' ? (b.name || '').localeCompare(a.name || '') : (a.name || '').localeCompare(b.name || ''));
    } else if (event.active === 'identifierNumber') {
      this.trademarks = this.trademarks.sort((a, b) => event.direction === 'desc' ? b.identifierNumber.localeCompare(a.identifierNumber) : a.identifierNumber.localeCompare(b.identifierNumber));
    } else if (event.active === 'countryOfDesignation') {
      this.trademarks = this.trademarks.sort((a, b) => event.direction === 'desc' ? this.translate.instant(`TERRITORIES.${b.countryOfDesignation.toUpperCase()}`).localeCompare(this.translate.instant(`TERRITORIES.${a.countryOfDesignation.toUpperCase()}`)) : this.translate.instant(`TERRITORIES.${a.countryOfDesignation.toUpperCase()}`).localeCompare(this.translate.instant(`TERRITORIES.${b.countryOfDesignation.toUpperCase()}`)));
    }
    this.dataSource = new MatTableDataSource<TrademarkDTO>(this.trademarks);
  }

  async newFamily() {
    const config: MatDialogConfig = {
      panelClass: 'dialog-container',
      width: '480px',
      data: {
      }
    }
    const dialog = this.dialog.open(CreateTrademarkFamilyDialogComponent, config);
    const result: { created: boolean, family?: Partial<TrademarkFamily> } = await firstValueFrom(dialog.afterClosed());
    if (result && result.created && result.family) {
      try {
        const toCreate: TrademarkFamilyCreate = {
          name: result.family.name,
          label: result.family.label,
          notes: result.family.notes,
          type: result.family.type,
          trademarks: []
        }
        this.family = await this.trademarkFamilyService.create(toCreate);
        this.toastr.success(this.translate.instant(`TRADEMARK_FAMILY.FAMILY_CREATED`, { name: toCreate.label }));
      } catch (err) {
        this.toastr.error(`ERRORS.GENERIC`)
      }

    }
  }


}
